import { type MCPServerInfo } from '../../types';

const SemgrepServer: MCPServerInfo = {
  serverId: 'SEMGREP',
  name: 'Semgrep',
  slug: 'semgrep',
  description:
    'Semgrep MCP Server - AI-powered code security scanning and vulnerability detection',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.semgrep.ai/mcp'
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default SemgrepServer;
